import { type ExtensionParams, type Parameters } from '@atlaskit/editor-common/extensions';

/**
 * Determines if the extension should be displayed as inline based on the extension parameters.
 * @param extensionParams - The extension parameters.
 * @returns True if the extension should be displayed as inline, false otherwise.
 */
export function shouldDisplayExtensionAsInline<T extends Parameters = Parameters>(
	extensionParams: ExtensionParams<T>,
): boolean {
	return Boolean(
		extensionParams.type === 'bodiedExtension' &&
		extensionParams.parameters?.macroParams?.['atlassian-macro-output-type']?.value === 'INLINE',
	);
}
